<div class="row">
  <div class="card shadow-none rounded">
    <div class="card-body">
      <div class="col-12 col-md-12 col-xxl-12 col-xl-12">
        <div class="d-flex row justify-content-center align-items-center">
          <div class="col-12 col-xxl-10 col-xl-10 col-md-10 col-lg-10 col-sm-8 mb-0">
            <h4 class="fw-bold">Accounting Policies - {{commonService.headerName}}</h4>
          </div>
          <div class="col-12 col-xxl-2 col-xl-2 col-md-2 col-lg-2 col-sm-4 text-start text-sm-end p-sm-0 pt-2 mb-0">
            <button type="button" class="btn btn-outline-themecolorlight" style="padding: 7px;font-weight: 600; font-size: 14px;"
                    tabindex="-1" (click)="TotalBack()">
              Close Accounts
            </button>
          </div>
        </div>
      </div>
      <div class="mb-3 font-size-14">This section allows you to enter any notes that are necessary to explain the entries in the Financial Statements.</div>
      <hr />
      <form [formGroup]="policyform">
        <div class="col-12 col-md-12 col-xxl-12 col-xl-12 col-lg-12  col-sm-12">
          <!--<div class="row mb-3">
        <div class="col-12">
          <h6 class="fw-bolder font-size-16">This section allows you to enter any notes that are necessary to explain the entries in the Financial Statements.</h6>
        </div>
      </div>-->

          <div class="row mb-4">
            <div class="col-12 col-xxl-12  col-xl-12 col-md-12 col-lg-12 col-sm-12">
              <div class="row">
                <h6 class="fw-bolder font-size-16 col-xxl-8">Basis of Preparation <span class="text-danger">*</span></h6>
                <div class="col-12 col-xxl-4 col-xl-12 col-md-12 col-lg-12 col-sm-12 text-right float-end">
                  <button class="btn btndef p-1 px-2 me-0 text-center float-end" type="button" [disabled]="disableDefaultButton" (click)="getDefaultStatement('BasisOfPreparation')">Default Statement</button>
                </div>
              </div>
                <div>
                  <textarea class="form-control string" [appTooltip]="showBubbledata" appNumberdirective rows="6" formControlName="BasisOfPreparation" maxlength="4000" required></textarea>
                </div>
            </div>
            <!--<div class="col-12 col-xxl-2 col-xl-12 col-md-12 col-lg-12 col-sm-12 mt-4 pt-2 pe-0 text-end text-right float-end ">
              <button class="btn btnsheet p-1 ps-3 pe-3 me-0" type="button" [disabled]="disableDefaultButton" (click)="getDefaultStatement('BasisOfPreparation')">Default Statement</button>
            </div>-->
          </div>

          <!--<div class="row mb-5">
        <div class="col-12 col-xxl-10 col-xl-12 col-md-12 col-lg-12 col-sm-12">
          <label>Basis of Preparation </label>
          <div class="mb-3">
            <textarea class="form-control allowSpecialChars" [appTooltip]="showBubbledata" appNumberdirective rows="6" formControlName="BasisOfPreparation" maxlength="1000" required></textarea>
          </div>
          <button class="btn btnsheet p-1 ps-3 pe-3" type="button" [disabled]="disableDefaultButton" (click)="getDefaultStatement('BasisOfPreparation')">Default Statement</button>
        </div>
      </div>-->
          <div class="row mb-4">
            <div class="col-12 col-xxl-12  col-xl-12 col-md-12 col-lg-12 col-sm-12">
              <div class="row">
                <h6 class="fw-bolder font-size-16 col-xxl-8"> Presentation currency <span class="text-danger">*</span></h6>
                <div class="col-12 col-xxl-4 col-xl-12 col-md-12 col-lg-12 col-sm-12 text-right float-end">
                  <button class="btn btndef p-1 px-2 me-0 text-center float-end" type="button" [disabled]="disableDefaultButton" (click)="getDefaultStatement('PresentationCurrency')">Default Statement</button>
                </div>
              </div>
              <div>
                <textarea class="form-control string" [appTooltip]="showBubbledata" appNumberdirective rows="6" formControlName="PresentationCurrency" maxlength="4000" required></textarea>
              </div>
            </div>

            </div>
          <!--<div class="row mb-5">
        <div class="col-12 col-xxl-10 col-xl-12 col-md-12 col-lg-12 col-sm-12">
          <label>Presentation currency  </label>
          <div class="mb-3">
            <textarea class="form-control allowSpecialChars" [appTooltip]="showBubbledata" appNumberdirective rows="6" formControlName="PresentationCurrency" maxlength="1000" required></textarea>
            <button class="btn btnsheet p-1 ps-3 pe-3" type="button" [disabled]="disableDefaultButton" (click)="getDefaultStatement('PresentationCurrency')">Default Statement</button>
          </div>
        </div>
      </div>-->
          <div class="row mb-1">
            <div class="col-12 col-xxl-12 col-xl-12 col-md-12 col-lg-12 col-sm-12">
              <div class="row">
                <h6 class="fw-bolder font-size-16">
                  Additional information
                </h6>
                <div class="mb-3">
                  <textarea class="form-control allowSpecialChars" [appTooltip]="showBubbledata" appNumberdirective rows="6" formControlName="AdditionalInformation" maxlength="4000"></textarea>
                </div>
                </div>
                </div>
              </div>
          <div class="row">
            <div class="col-12 col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 text-end mt-0">
              <button type="button" class="btn btn-outline-back p-1 ps-3 pe-3 me-2" (click)="back()">Back</button>
              <button type="button" class="btn themedefault p-1 ps-3 pe-3 ms-1 me-0" (click)="Insertpolicy()">Next</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
